<template>
  <template v-if="props.node.value === ''" />
  <CMSTextMarks v-else :marks="props.node.marks">
    <template #default="{ marksClasses }">
      <span :class="marksClasses">
        <template v-for="(line, index) in lines" :key="`line-${index}`">
          <template v-if="line">{{ line }}</template>
          <br v-if="index < lines.length - 1" />
        </template>
      </span>
    </template>
  </CMSTextMarks>
</template>

<script setup lang="ts">
import type { Text } from '@contentful/rich-text-types'
import { computed } from 'vue'
import CMSTextMarks from './CMSTextMarks.vue'

const props = defineProps<{
  node: Text
}>()

const lines = computed(() => props.node.value?.split(/\r?\n/) || [])

defineOptions({
  name: 'CMSTextNode',
})
</script>
